import { useTranslation } from 'react-i18next';
import RelatedApproval from '@/components/Approval/RelatedApproval';
import { FieldBlock, FieldHeader } from './styles';
import { InfoSectionTitle } from '@/components/Approval/@components/InfoSection';

type RelatedApprovalFieldProps = {
  /** 저장된 문서번호 — 기존 연관품의 초기 로드 키 + 검색 결과에서 자기 문서 제외용 */
  documentId?: string;
};

const RelatedApprovalField = ({ documentId }: RelatedApprovalFieldProps) => {
  const { t } = useTranslation();
  return (
    <FieldBlock>
      <FieldHeader>
        <InfoSectionTitle>{t('연결된 품의')}</InfoSectionTitle>
      </FieldHeader>
      <RelatedApproval documentId={documentId} />
    </FieldBlock>
  );
};

export default RelatedApprovalField;
